// src/pages/History/EarlyModern/AztecIncaEmpiresGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Early_Modern_Period_-_Aztec_and_Inca_Empires.png';

function HistoryPageAztecIncaEmpiresGo() {
  return (
    <QuizPage
      title="History: Aztec and Inca Empires"
      subTopic="Aztec and Inca Empires"
      backgroundImage={historyImage}
      returnPath="/History-Aztec-Inca-Empires"
    />
  );
}

export default HistoryPageAztecIncaEmpiresGo;
